/**
 *  ------------------------------------
 *  Imports
 *  ------------------------------------
 */
import {FunctionComponent, useEffect, useState} from 'react';

import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import HelpBox from 'components/helpbox/HelpBox';
import InfoBox from "../components/infobox/InfoBox";
import MaintenanceNotice from 'components/maintenance/MaintenanceNotice';
import TestModeBanner from 'components/maintenance/TestModeBanner';
import BackToTopButton from 'components/backToTopButton/BackToTopButton';
import AppRoutes from 'app/AppRoutes';
import useStorage from 'hooks/useStorage';
import useIsInselNetwork from 'hooks/useIsInselNetwork';

import { fetchAPI } from 'services/fetchAPI';
import { MaintenanceProvider } from 'contexts/MaintenanceContext';
import { MaintenanceType } from 'types/MaintenanceType';

import './App.scss';

/**
 *  ------------------------------------
 *  App Component
 *  ------------------------------------
 */
const App: FunctionComponent = () => {

    const [registrationData, setRegistrationData] = useStorage('registrationData', {});
    const [langChange, setLangChange] = useState<string>('');
    const [maintenanceData, setMaintenanceData] = useState<MaintenanceType>({ maintenance: false });
    const [maintenanceLoaded, setMaintenanceLoaded] = useState(false);
    const { isInsel, loaded: isInselLoaded } = useIsInselNetwork();

    useEffect(() => {
        if (registrationData && Object.keys(registrationData).length) {
            // clear stored registration data
            //setRegistrationData({});  //currently disabled
            setRegistrationData(registrationData);
        }
    }, [registrationData, setRegistrationData]);

    useEffect(() => {
        fetchAPI("/maintenance")
            .then((result) => setMaintenanceData(result as MaintenanceType))
            .catch((err) => { return console.log(err); })
            .finally(() => setMaintenanceLoaded(true));
    }, [langChange]);

    return (
        <MaintenanceProvider value={{ ...maintenanceData, isInsel, loaded: maintenanceLoaded && isInselLoaded }}>
            <div className="app">
                <Header setLangChange={setLangChange} />
                <HelpBox />
                <TestModeBanner />
                <InfoBox langChange={langChange}/>
                <MaintenanceNotice />
                <AppRoutes />
                <Footer />
                <BackToTopButton />
            </div>
        </MaintenanceProvider>
    );
}

/**
 *  ------------------------------------
 *  Exports
 *  ------------------------------------
 */
export default App;